import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const CoursePopup = ({ course, onClose }) => {
  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
  };

  return (
    <div
      className="popup-overlay"
      onClick={onClose}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        className="popup-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          position: "relative",
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "8px",
          maxWidth: "900px",
          width: "90%",
          display: "flex",
          gap: "20px",
          flexDirection: "row",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "red",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: "30px",
            height: "30px",
            cursor: "pointer",
          }}
        >
          ×
        </button>

        {/* Left: Image Carousel */}
        <div style={{ flex: "1", minWidth: "50%" }}>
          <Carousel
            responsive={responsive}
            infinite
            autoPlay
            autoPlaySpeed={3000}
            arrows={false}
            showDots={true}
          >
            {course.images.map((img, index) => (
              <div key={index}>
                <img
                  src={img}
                  alt={`${course.title} ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />
              </div>
            ))}
          </Carousel>
        </div>

        {/* Right: Text Content */}
        <div style={{ flex: "1", minWidth: "50%", textAlign: "left" }}>
          <h2 style={{ marginBottom: "20px" }}>{course.title}</h2>
          <p style={{ marginBottom: "20px" }}>{course.description}</p>
          <ul>
            {course.equipment.map((item, i) => (
              <li key={i} style={{ marginBottom: "10px" }}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CoursePopup;
